import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=ae0033e8&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&id=ae0033e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0033e8",
  null
  
)

export default component.exports